import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BRAND } from "../data";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/chi-sono", label: "Chi Sono" },
  { to: "/servizi", label: "Servizi" },
  { to: "/contatti", label: "Contatti" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#0c0c0c]/85 backdrop-blur-xl border-b border-stone-800" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex flex-col leading-none">
          <span className="font-serif text-xl md:text-2xl tracking-wide text-white">
            {BRAND.name}
          </span>
          <span className="text-[10px] uppercase tracking-[0.35em] text-gold mt-1">
            {BRAND.suffix}
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-9">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-link-${item.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `text-sm uppercase tracking-[0.15em] transition-colors duration-300 hover:text-gold ${
                  isActive ? "text-gold" : "text-stone-300"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/contatti"
            data-testid="nav-cta-button"
            className="bg-gold text-[#0c0c0c] text-xs uppercase tracking-[0.15em] px-5 py-3 font-medium hover:bg-[#b5952f] transition-colors duration-300"
          >
            Consulenza Gratuita
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-[#0c0c0c]/98 backdrop-blur-xl border-t border-stone-800 px-6 py-6 flex flex-col gap-5">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `text-base uppercase tracking-[0.15em] ${isActive ? "text-gold" : "text-stone-200"}`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/contatti"
            className="bg-gold text-[#0c0c0c] text-center text-sm uppercase tracking-[0.15em] px-5 py-3 font-medium mt-2"
          >
            Consulenza Gratuita
          </Link>
        </div>
      )}
    </header>
  );
};

export default Navbar;
